import Vue from 'vue';
import organizationMemberBookingTransformer from './../../transformers/organizationMemberBooking';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('addOrganizationMemberBooking', organizationMemberBookingTransformer.fetch(data));
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors.message);
};

export default organizationMemberBooking => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/organization_member_bookings', organizationMemberBookingTransformer.send(organizationMemberBooking))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMemberBooking/store.js